window.hederaSyncPreorderProperty = function (form, state) {
  if (!form) return;

  const control = form.querySelector("[data-hd-preorder-control]");
  if (!control) return;

  control.dataset.hdPreorderState = state;
  const propertyInput = form.querySelector("[data-hd-preorder-property]");

  if (state !== "preorder") {
    if (propertyInput) propertyInput.remove();
    return;
  }

  if (propertyInput) return;
  const template = form.querySelector("[data-hd-preorder-template]");
  if (template) form.appendChild(template.content.cloneNode(true));
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        const preorderControl = this.form.querySelector(
          "[data-hd-preorder-control]"
        );
        if (preorderControl) {
          window.hederaSyncPreorderProperty(
            this.form,
            preorderControl.dataset.hdPreorderState
          );
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.form.dataset.hdProductInfoPending === "true" || this.submitting) return;

        const regularButton = this.querySelector('[type="submit"]');
        const submitButton = evt.submitter || regularButton;
        if (!submitButton || regularButton?.disabled || submitButton.disabled) return;
        this.submitting = true;
        const activeButtons = Array.from(this.form.querySelectorAll('button[type="submit"]:not(:disabled)'));
        activeButtons.forEach((button) => button.setAttribute("disabled", true));
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const preorderControl = this.form.querySelector(
          "[data-hd-preorder-control]"
        );
        if (preorderControl) {
          window.hederaSyncPreorderProperty(
            this.form,
            preorderControl.dataset.hdPreorderState
          );
        }

        let formData = new FormData(this.form);
        const offerQuantity = Number.parseInt(submitButton.dataset.hdOfferQuantity, 10);
        if (Number.isInteger(offerQuantity) && offerQuantity > 0) {
          formData.set("quantity", String(offerQuantity));
        }
        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        let addedToCart = false;
        fetch(`${routes.cart_add_url}`, config)
          .then(async (response) => ({
            ok: response.ok,
            state: await response.json(),
          }))
          .then(({ ok, state: parsedState }) => {
            if (parsedState.status) {
              this.handleErrorMessage(
                window.hederaTranslateCartError(parsedState.description)
              );
              return;
            }
            if (!ok) {
              this.handleErrorMessage(window.cartStrings.error);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            this.handleErrorMessage(false);
            addedToCart = true;
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitting = false;
            submitButton.classList.remove("loading");
            const variantId = this.form.querySelector('input[name="id"]')?.value;
            const state = this.form.querySelector("[data-hd-preorder-control]")
              ?.dataset.hdPreorderState;
            if (variantId && state !== "unavailable" &&
                this.form.dataset.hdProductInfoPending !== "true")
              activeButtons.forEach((button) => button.removeAttribute("disabled"));
            if (addedToCart) {
              this.quickViewWarpper?.classList.remove("show__modal");
              document.body.classList.remove("overflow-hidden");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (!errorMessage && !this.errorMessageWrapper &&
            !this.querySelector(".product-form__error-message-wrapper")) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) {
          this.errorMessageWrapper = document.createElement("div");
          this.errorMessageWrapper.className = "product-form__error-message-wrapper no-js-inline";
          this.errorMessageWrapper.setAttribute("role", "alert");
          this.errorMessageWrapper.hidden = true;
          const message = document.createElement("span");
          message.className = "product-form__error-message";
          this.errorMessageWrapper.appendChild(message);
          this.insertBefore(this.errorMessageWrapper, this.form);
        }
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        // Base CSS gives this wrapper display:flex, which can override the
        // browser's hidden attribute. Keep the theme's hiding class in sync.
        this.errorMessageWrapper.classList.toggle("no-js-inline", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
